module.exports = __webpack_public_path__ + "img/stars.c93d5508.svg";